import { Theme } from '@mui/material'

/** Deterministic two-letter initials derived from the actor name. */
export function getInitials(name: string): string {
  const cleaned = name.replace(/[—–-]/g, ' ').replace(/\([^)]*\)/g, ' ')
  const tokens = cleaned.split(/\s+/).filter((w) => /[A-Za-zÀ-ÿ]/.test(w))
  if (tokens.length === 0) return name.slice(0, 2).toUpperCase()
  if (tokens.length === 1) return tokens[0].slice(0, 2).toUpperCase()
  return (tokens[0][0] + tokens[1][0]).toUpperCase()
}

/** Deterministic avatar color from the name. */
export function getAvatarColor(name: string, theme: Theme): string {
  const palette = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.info?.main,
    theme.palette.success?.main,
    theme.palette.warning?.main,
  ].filter(Boolean) as string[]
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0
  return palette[hash % palette.length]
}
